import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Application } from '../interface/application';
@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  httpOptions: any;
  headers: any;
  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      })
    };
  }

  getApplicationCode(url) {
    return this.http.get(url, this.httpOptions)
  }
  getAllApplication(url) {
    return this.http.get(url, this.httpOptions)
  }

  postApplication(url, param) {
    return this.http.post<Application>(url, param, this.httpOptions)
  }


  updateApplication(url, param) {
    return this.http.put<Application>(url, param, this.httpOptions)
  }
}

